import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Card,
  Block,
  Content,
  AuthorDetails,
  StyledImage,
  Author,
  AuthorImage,
  Footer,
} from './styles';

// * sectionTiles {obj} richtext obj provided by primsic
// * items {array} array of data from prismic for each card. Contains a heading {string}, image src {string}, bodyCopy {string}

const CaseStudySection = ({ sectionId, data }) => {
  if (!data) return null;
  const {
    sectionTitleHtml,
    sectionSubtitleHTML,
    columnAlignment,
    items,
    titleHtml,
    buttonLink,
    buttonText,
    buttonType,
    ariaLabelButton,
    queryStringButton,
    colourOverrideBackground,
    focusTextColour,
    imageBackground,
    imageBackgroundSharp,
  } = data;
  return (
    <Wrapper
      colourOverrideBackground={colourOverrideBackground}
      background={imageBackground.url ? imageBackgroundSharp.publicURL : null}
    >
      <StyledContainer
        id={sectionId}
        className="auto-margin episode-section"
        focusTextColour={focusTextColour}
      >
        {ReactHtmlParser(sectionTitleHtml)}
        <div className="case-study-subtitle">
          {ReactHtmlParser(sectionSubtitleHTML)}
        </div>
        <Columns className="regular-columns case-study-columns" columns={3}>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                imageAuthor,
                imageAuthorSharp,
                authorNameHtml,
                authorTitleHtml,
                authorLocationHtml,
                itemHeadingHtml,
                itemSubHeadingHtml,
                itemBodyCopyHtml,
                cta,
                ctaText,
              },
              index
            ) => {
              return (
                <Block
                  className={columnAlignment}
                  key={`values-${columnAlignment}-${index.toString()}`}
                >
                  {cta && (
                    <Link to={`${cta.url}/`} className="casestudylink">
                      <Card>
                        {imageItemSharp && (
                          <StyledImage
                            src={imageItemSharp}
                            alt={itemImage.altTag}
                            className="case-study-image"
                          />
                        )}
                        <Content>
                          {ReactHtmlParser(itemHeadingHtml)}
                          {ReactHtmlParser(itemSubHeadingHtml)}
                          <p className="body-content">
                            {ReactHtmlParser(itemBodyCopyHtml)}
                          </p>
                          <Author>
                            {imageAuthor && (
                              <AuthorImage
                                src={imageAuthorSharp}
                                alt={imageAuthor.altTag}
                                className="author-image"
                              />
                            )}
                            <AuthorDetails className="author-details">
                              {ReactHtmlParser(authorNameHtml)}
                              {ReactHtmlParser(authorTitleHtml)}
                              {ReactHtmlParser(authorLocationHtml)}
                            </AuthorDetails>
                          </Author>
                          {cta && ctaText && (
                            <Link
                              to={`${cta.url}/`}
                              className={`casestudy-cta ${buttonType}`}
                              ariaLabel={ariaLabelButton}
                              queryString={queryStringButton}
                            >
                              {ctaText}
                            </Link>
                          )}
                        </Content>
                      </Card>
                    </Link>
                  )}
                </Block>
              );
            }
          )}
        </Columns>
        {(titleHtml || buttonText) && (
          <Footer>
            {ReactHtmlParser(titleHtml)}
            {buttonLink && buttonText && (
              <Link
                to={`${buttonLink.url}/`}
                className={buttonType}
                ariaLabel={ariaLabelButton}
                queryString={queryStringButton}
              >
                {buttonText}
              </Link>
            )}
          </Footer>
        )}
      </StyledContainer>
    </Wrapper>
  );
};
CaseStudySection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default CaseStudySection;
